import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import RequireAuth from './components/auth/RequireAuth';
import LoginPage from './pages/LoginPage';
import ProjectHubWrapper from './pages/ProjectHubWrapper';

function App() {
  return (
    <AuthProvider>
      <div className="App h-screen flex flex-col overflow-hidden">
        <div className="flex-1 overflow-hidden">
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/*"
              element={(
                <RequireAuth>
                  <ProjectHubWrapper />
                </RequireAuth>
              )}
            />
          </Routes>
        </div>
      </div>
    </AuthProvider>
  );
}

export default App;